export const APPOINTMENT_CRITERIA = {
	reasonForVisit: 'reasonForVisit',
	externalReferralOrderId: 'externalReferralOrderId',
	agentAvailabilityInstructions: 'agentAvailabilityInstructions',
	agentReservationInstructions: 'agentReservationInstructions',
	agentPostBookingInstructions: 'agentPostBookingInstructions',
};
